import Course from '../pages/spiritual/Course.vue'
import Router from "vue-router";
import store1 from "../store/index.js";

import Landing from "../pages/common-apps/Landing.vue";

const baseRoutes = [
  {
    path: '/',
    redirect: { name: 'Landing' }
  },
  {
    path: '/landing',
    name: 'Landing',
    component: Landing,
    meta: { bodyClass: 'landing-page' }
  }
] // to comment Landing route when using on dev mode

const spiritualRoutes = [
  {
    path: '/courses',
    name: 'Spiritual Courses',
    component: Course,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: '/courses/:id',
    name: 'Spiritual Courses Details',
    component: () => import(/* webpackChunkName: "coursedetails" */ "../pages/spiritual/CourseDetails.vue"),
    // component: TicketDetails,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
]

const routes = baseRoutes.concat(spiritualRoutes)

const routerSpiritual = new Router({
  routes,
  base: 'spi',
  mode: 'history'
})

routerSpiritual.beforeEach((to, from, next) => {
  // vueBodyClass.guard(to, next)
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store1.getters['account/isAuthenticated']) {
      next()
      return
    }
    next('/landing')
  } else {
    next()
  }
})


export default routerSpiritual